import http from './http'

const participant = {

  async createNewOne (args) {
    console.log('[participant]createNewOne')
    const { data } = await http.api.post('/participant', args)
    return data
  },

  async registerContest () {
    console.log('[participant]registerContest')
    const { data } = await http.api.get('/participant/register/inscription')
    return data
  },

  async registerClass (doc) {
    console.log('[participant]registerClass')
    const { data } = await http.api.post('/participant/register/class', doc)
    return data
  },

  async getClasses () {
    console.log('[participant]getClasses')
    const { data } = await http.api.get('/participant/classes')
    return data
  },

  async updateInscriptionPaymentMode (args) {
    console.log('[admin]updateInscriptionPaymentMode')
    const { data } = await http.api.put('/participant/inscription/payment-mode', args)
    return data
  },
}

export default participant
